export default class AdresseLadApiDriveService {
  cardActivationPath = "api/formulaires/activationCarteMalin";
  cardRequestPath = "api/formulaires/demandeCarteMalin";

  constructor(httpApi) {
    this.httpApi = httpApi;
  }

  /**
   * Demande d'une carte Malin
   * @param {Object} data
   */
  async askForCard(data) {
    const config = { ...this.httpApi.getConfig(), ...{ tokenClient: true } };
    const response = await this.httpApi.post(this.cardRequestPath, data, config);
    return response.data
  }

  /**
   * Activation d'une carte malin 
   * @param {Object} data
   */
  async activateCard(data) {
    const res = await this.httpApi.post(this.cardActivationPath, data);
    return res.data;
  }
}
